import * as React from 'react'
import Icon from 'react-markdown-editor-lite/cjs/components/Icon'
import i18n from 'react-markdown-editor-lite/cjs/i18n'
import { PluginComponent } from 'react-markdown-editor-lite/cjs/plugins/Plugin'
import { UploadFunc } from 'react-markdown-editor-lite/cjs/share/var'
import { isPromise } from 'react-markdown-editor-lite/cjs/utils/tool'
import InputFile from './inputFile'
import Axios from 'axios'

interface State {
  show: boolean
}

export default class Image extends PluginComponent<State> {
  static pluginName = 'customImage'

  private inputFile: React.RefObject<InputFile>

  constructor(props: any) {
    super(props)

    this.inputFile = React.createRef()
    this.onImageChanged = this.onImageChanged.bind(this)
    this.handleCustomImageUpload = this.handleCustomImageUpload.bind(this)
    this.handleImageUpload = this.handleImageUpload.bind(this)

    this.state = {
      show: false,
    }
  }

  private handleImageUpload() {
    const { onImageUpload } = this.editorConfig
    if (typeof onImageUpload === 'function') {
      if (this.inputFile.current) {
        this.inputFile.current.click()
      }
    } else {
      this.editor.insertMarkdown('image')
    }
  }

  private onImageChanged(file: File) {
    const { onImageUpload } = this.editorConfig
    if (onImageUpload) {
      const getUploadPlaceholder = (file: File, onImageUpload: UploadFunc) => {
        var placeholder = 'uploading..'
        var uploaded = new Promise<string>(function(resolve) {
          var handleUploaded = async (url: string) => {
            const saveFile = file.name

            const resFileName = await Axios.post('/api/upload/image', {
              fileData: url,
              saveFile,
            })

            if (resFileName) {
              const text =
                '![' + file.name + '](' + (resFileName.data || '') + ')'
              resolve(text)
            }
          }

          var upload = onImageUpload(file, handleUploaded)
          if (upload) {
            upload.then(handleUploaded)
          }
        })
        return {
          placeholder: placeholder,
          uploaded: uploaded,
        }
      }
      const placeholder = getUploadPlaceholder(file, onImageUpload)

      this.editor.insertPlaceholder(
        placeholder.placeholder,
        placeholder.uploaded
      )
    }
  }

  private handleCustomImageUpload(e: any) {
    const { onCustomImageUpload } = this.editorConfig
    if (onCustomImageUpload) {
      const res = onCustomImageUpload.call(this, e)
      if (isPromise(res)) {
        res.then(result => {
          if (result && result.url) {
            this.editor.insertMarkdown('image', {
              target: result.text,
              imageUrl: result.url,
            })
          }
        })
      }
    }
  }

  render() {
    const isCustom = !!this.editorConfig.onCustomImageUpload
    return isCustom ? (
      <span
        className="button button-type-image"
        title={i18n.get('btnImage')}
        onClick={this.handleCustomImageUpload}
      >
        <Icon type="image" />
      </span>
    ) : (
      <span
        className="button button-type-image"
        title={i18n.get('btnImage')}
        onClick={this.handleImageUpload}
        style={{ position: 'relative' }}
      >
        <Icon type="image" />
        <InputFile
          accept={this.editorConfig.imageAccept || ''}
          ref={this.inputFile}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            e.persist()
            if (e.target.files && e.target.files.length > 0) {
              this.onImageChanged(e.target.files[0])
            }
          }}
        />
      </span>
    )
  }
}
